import script from "./EducationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationItem.vue?vue&type=script&setup=true&lang=js"

import "./EducationItem.vue?vue&type=style&index=0&id=57603c80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57603c80"]])

export default __exports__